'use client';
"use strict";

var _excluded = ["isIndeterminate", "isChecked"],
    _excluded2 = ["defaultChecked", "isChecked", "isFocusable", "onChange", "isIndeterminate", "name", "value", "tabIndex", "aria-label", "aria-labelledby", "aria-invalid"],
    _excluded3 = ["spacing", "className", "children", "iconColor", "iconSize", "icon", "isChecked", "isDisabled", "onChange", "inputProps"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var src_exports = {};

__export(src_exports, {
  Checkbox: function Checkbox() {
    return _Checkbox;
  },
  CheckboxGroup: function CheckboxGroup() {
    return _CheckboxGroup;
  },
  CheckboxIcon: function CheckboxIcon() {
    return _CheckboxIcon;
  },
  useCheckbox: function useCheckbox() {
    return _useCheckbox;
  },
  useCheckboxGroup: function useCheckboxGroup() {
    return _useCheckboxGroup;
  }
});

module.exports = __toCommonJS(src_exports); // src/checkbox.tsx

var import_shared_utils2 = require("@chakra-ui/shared-utils");

var import_system2 = require("@chakra-ui/system");

var import_react3 = require("react"); // src/checkbox-context.ts


var import_react_context = require("@chakra-ui/react-context");

var _ref = (0, import_react_context.createContext)({
  name: "CheckboxGroupContext",
  strict: false
}),
    _ref2 = _slicedToArray(_ref, 2),
    CheckboxGroupProvider = _ref2[0],
    useCheckboxGroupContext = _ref2[1]; // src/checkbox-icon.tsx


var import_system = require("@chakra-ui/system");

var import_jsx_runtime = require("react/jsx-runtime");

function CheckIcon(props) {
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.svg, _objectSpread(_objectSpread({
    width: "1.2em",
    viewBox: "0 0 12 10",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "currentColor",
      strokeDasharray: 16
    }
  }, props), {}, {
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)("polyline", {
      points: "1.5 6 4.5 9 10.5 1"
    })
  }));
}

function IndeterminateIcon(props) {
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.svg, _objectSpread(_objectSpread({
    width: "1.2em",
    viewBox: "0 0 24 24",
    style: {
      stroke: "currentColor",
      strokeWidth: 4
    }
  }, props), {}, {
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)("line", {
      x1: "21",
      x2: "3",
      y1: "12",
      y2: "12"
    })
  }));
}

function _CheckboxIcon(props) {
  var isIndeterminate = props.isIndeterminate,
      isChecked = props.isChecked,
      rest = _objectWithoutProperties(props, _excluded);

  var BaseIcon = isIndeterminate ? IndeterminateIcon : CheckIcon;
  return isChecked || isIndeterminate ? /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.div, {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%"
    },
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(BaseIcon, _objectSpread({}, rest))
  }) : null;
} // src/use-checkbox.ts


var import_form_control = require("@chakra-ui/form-control");

var import_react_use_safe_layout_effect = require("@chakra-ui/react-use-safe-layout-effect");

var import_react_use_update_effect = require("@chakra-ui/react-use-update-effect");

var import_react_use_callback_ref = require("@chakra-ui/react-use-callback-ref");

var import_react_use_merge_refs = require("@chakra-ui/react-use-merge-refs");

var import_shared_utils = require("@chakra-ui/shared-utils"); // ../../utilities/object-utils/src/omit.ts


function omit(object) {
  var keysToOmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var clone = Object.assign({}, object);

  var _iterator2 = _createForOfIteratorHelper(keysToOmit),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var key = _step2.value;

      if (key in clone) {
        delete clone[key];
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return clone;
} // src/use-checkbox.ts


var import_visually_hidden = require("@chakra-ui/visually-hidden");

var import_focus_visible = require("@zag-js/focus-visible");

var import_react = require("react");

function _useCheckbox() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var formControlProps = (0, import_form_control.useFormControlProps)(props);
  var isDisabled = formControlProps.isDisabled,
      isReadOnly = formControlProps.isReadOnly,
      isRequired = formControlProps.isRequired,
      isInvalid = formControlProps.isInvalid,
      id = formControlProps.id,
      onBlur = formControlProps.onBlur,
      onFocus = formControlProps.onFocus,
      ariaDescribedBy = formControlProps["aria-describedby"];

  var defaultChecked = props.defaultChecked,
      checkedProp = props.isChecked,
      isFocusable = props.isFocusable,
      onChange = props.onChange,
      isIndeterminate = props.isIndeterminate,
      name = props.name,
      value = props.value,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? void 0 : _props$tabIndex,
      ariaLabel = props["aria-label"],
      ariaLabelledBy = props["aria-labelledby"],
      ariaInvalid = props["aria-invalid"],
      rest = _objectWithoutProperties(props, _excluded2);

  var htmlProps = omit(rest, ["isDisabled", "isReadOnly", "isRequired", "isInvalid", "id", "onBlur", "onFocus", "aria-describedby"]);
  var onChangeProp = (0, import_react_use_callback_ref.useCallbackRef)(onChange);
  var onBlurProp = (0, import_react_use_callback_ref.useCallbackRef)(onBlur);
  var onFocusProp = (0, import_react_use_callback_ref.useCallbackRef)(onFocus);

  var _ref3 = (0, import_react.useState)(false),
      _ref4 = _slicedToArray(_ref3, 2),
      isFocusVisible = _ref4[0],
      setIsFocusVisible = _ref4[1];

  var _ref5 = (0, import_react.useState)(false),
      _ref6 = _slicedToArray(_ref5, 2),
      isFocused = _ref6[0],
      setFocused = _ref6[1];

  var _ref7 = (0, import_react.useState)(false),
      _ref8 = _slicedToArray(_ref7, 2),
      isHovered = _ref8[0],
      setHovered = _ref8[1];

  var _ref9 = (0, import_react.useState)(false),
      _ref10 = _slicedToArray(_ref9, 2),
      isActive = _ref10[0],
      setActive = _ref10[1];

  (0, import_react.useEffect)(function () {
    return (0, import_focus_visible.trackFocusVisible)(setIsFocusVisible);
  }, []);
  var inputRef = (0, import_react.useRef)(null);

  var _ref11 = (0, import_react.useState)(true),
      _ref12 = _slicedToArray(_ref11, 2),
      rootIsLabelElement = _ref12[0],
      setRootIsLabelElement = _ref12[1];

  var _ref13 = (0, import_react.useState)(!!defaultChecked),
      _ref14 = _slicedToArray(_ref13, 2),
      checkedState = _ref14[0],
      setCheckedState = _ref14[1];

  var isControlled = checkedProp !== void 0;
  var isChecked = isControlled ? checkedProp : checkedState;
  var handleChange = (0, import_react.useCallback)(function (event) {
    if (isReadOnly || isDisabled) {
      event.preventDefault();
      return;
    }

    if (!isControlled) {
      if (isChecked) {
        setCheckedState(event.target.checked);
      } else {
        setCheckedState(isIndeterminate ? true : event.target.checked);
      }
    }

    onChangeProp == null ? void 0 : onChangeProp(event);
  }, [isReadOnly, isDisabled, isChecked, isControlled, isIndeterminate, onChangeProp]);
  (0, import_react_use_safe_layout_effect.useSafeLayoutEffect)(function () {
    if (inputRef.current) {
      inputRef.current.indeterminate = Boolean(isIndeterminate);
    }
  }, [isIndeterminate]);
  (0, import_react_use_update_effect.useUpdateEffect)(function () {
    if (isDisabled) {
      setFocused(false);
    }
  }, [isDisabled, setFocused]);
  (0, import_react_use_safe_layout_effect.useSafeLayoutEffect)(function () {
    var el = inputRef.current;
    if (!(el == null ? void 0 : el.form)) return;

    var formResetListener = function formResetListener() {
      setCheckedState(!!defaultChecked);
    };

    el.form.addEventListener("reset", formResetListener);
    return function () {
      var _a;

      return (_a = el.form) == null ? void 0 : _a.removeEventListener("reset", formResetListener);
    };
  }, []);
  var trulyDisabled = isDisabled && !isFocusable;
  var onKeyDown = (0, import_react.useCallback)(function (event) {
    if (event.key === " ") {
      setActive(true);
    }
  }, [setActive]);
  var onKeyUp = (0, import_react.useCallback)(function (event) {
    if (event.key === " ") {
      setActive(false);
    }
  }, [setActive]);
  (0, import_react_use_safe_layout_effect.useSafeLayoutEffect)(function () {
    if (!inputRef.current) return;
    var notInSync = inputRef.current.checked !== isChecked;

    if (notInSync) {
      setCheckedState(inputRef.current.checked);
    }
  }, [inputRef.current]);
  var getCheckboxProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var onPressDown = function onPressDown(event) {
      if (isFocused) {
        event.preventDefault();
      }

      setActive(true);
    };

    return _objectSpread(_objectSpread({}, props2), {}, {
      ref: forwardedRef,
      "data-active": (0, import_shared_utils.dataAttr)(isActive),
      "data-hover": (0, import_shared_utils.dataAttr)(isHovered),
      "data-checked": (0, import_shared_utils.dataAttr)(isChecked),
      "data-focus": (0, import_shared_utils.dataAttr)(isFocused),
      "data-focus-visible": (0, import_shared_utils.dataAttr)(isFocused && isFocusVisible),
      "data-indeterminate": (0, import_shared_utils.dataAttr)(isIndeterminate),
      "data-disabled": (0, import_shared_utils.dataAttr)(isDisabled),
      "data-invalid": (0, import_shared_utils.dataAttr)(isInvalid),
      "data-readonly": (0, import_shared_utils.dataAttr)(isReadOnly),
      "aria-hidden": true,
      onMouseDown: (0, import_shared_utils.callAllHandlers)(props2.onMouseDown, onPressDown),
      onMouseUp: (0, import_shared_utils.callAllHandlers)(props2.onMouseUp, function () {
        return setActive(false);
      }),
      onMouseEnter: (0, import_shared_utils.callAllHandlers)(props2.onMouseEnter, function () {
        return setHovered(true);
      }),
      onMouseLeave: (0, import_shared_utils.callAllHandlers)(props2.onMouseLeave, function () {
        return setHovered(false);
      })
    });
  }, [isActive, isChecked, isDisabled, isFocused, isFocusVisible, isHovered, isIndeterminate, isInvalid, isReadOnly]);
  var getIndicatorProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({}, props2), {}, {
      ref: forwardedRef,
      "data-active": (0, import_shared_utils.dataAttr)(isActive),
      "data-hover": (0, import_shared_utils.dataAttr)(isHovered),
      "data-checked": (0, import_shared_utils.dataAttr)(isChecked),
      "data-focus": (0, import_shared_utils.dataAttr)(isFocused),
      "data-focus-visible": (0, import_shared_utils.dataAttr)(isFocused && isFocusVisible),
      "data-indeterminate": (0, import_shared_utils.dataAttr)(isIndeterminate),
      "data-disabled": (0, import_shared_utils.dataAttr)(isDisabled),
      "data-invalid": (0, import_shared_utils.dataAttr)(isInvalid),
      "data-readonly": (0, import_shared_utils.dataAttr)(isReadOnly)
    });
  }, [isActive, isChecked, isDisabled, isFocused, isFocusVisible, isHovered, isIndeterminate, isInvalid, isReadOnly]);
  var getRootProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread(_objectSpread({}, htmlProps), props2), {}, {
      ref: (0, import_react_use_merge_refs.mergeRefs)(forwardedRef, function (node) {
        if (!node) return;
        setRootIsLabelElement(node.tagName === "LABEL");
      }),
      onClick: (0, import_shared_utils.callAllHandlers)(props2.onClick, function () {
        var _a;

        if (!rootIsLabelElement) {
          (_a = inputRef.current) == null ? void 0 : _a.click();
          requestAnimationFrame(function () {
            var _a2;

            (_a2 = inputRef.current) == null ? void 0 : _a2.focus({
              preventScroll: true
            });
          });
        }
      }),
      "data-disabled": (0, import_shared_utils.dataAttr)(isDisabled),
      "data-checked": (0, import_shared_utils.dataAttr)(isChecked),
      "data-invalid": (0, import_shared_utils.dataAttr)(isInvalid)
    });
  }, [htmlProps, isDisabled, isChecked, isInvalid, rootIsLabelElement]);
  var getInputProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({}, props2), {}, {
      ref: (0, import_react_use_merge_refs.mergeRefs)(inputRef, forwardedRef),
      type: "checkbox",
      name: name,
      value: value,
      id: id,
      tabIndex: tabIndex,
      onChange: (0, import_shared_utils.callAllHandlers)(props2.onChange, handleChange),
      onBlur: (0, import_shared_utils.callAllHandlers)(props2.onBlur, onBlurProp, function () {
        return setFocused(false);
      }),
      onFocus: (0, import_shared_utils.callAllHandlers)(props2.onFocus, onFocusProp, function () {
        return setFocused(true);
      }),
      onKeyDown: (0, import_shared_utils.callAllHandlers)(props2.onKeyDown, onKeyDown),
      onKeyUp: (0, import_shared_utils.callAllHandlers)(props2.onKeyUp, onKeyUp),
      required: isRequired,
      checked: isChecked,
      disabled: trulyDisabled,
      readOnly: isReadOnly,
      "aria-label": ariaLabel,
      "aria-labelledby": ariaLabelledBy,
      "aria-invalid": ariaInvalid ? Boolean(ariaInvalid) : isInvalid,
      "aria-describedby": ariaDescribedBy,
      "aria-disabled": isDisabled,
      style: import_visually_hidden.visuallyHiddenStyle
    });
  }, [name, value, id, handleChange, onBlurProp, onFocusProp, onKeyDown, onKeyUp, isRequired, isChecked, trulyDisabled, isReadOnly, ariaLabel, ariaLabelledBy, ariaInvalid, isInvalid, ariaDescribedBy, isDisabled, tabIndex]);
  var getLabelProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({}, props2), {}, {
      ref: forwardedRef,
      onMouseDown: (0, import_shared_utils.callAllHandlers)(props2.onMouseDown, stopEvent),
      "data-disabled": (0, import_shared_utils.dataAttr)(isDisabled),
      "data-checked": (0, import_shared_utils.dataAttr)(isChecked),
      "data-invalid": (0, import_shared_utils.dataAttr)(isInvalid)
    });
  }, [isChecked, isDisabled, isInvalid]);
  var state = {
    isInvalid: isInvalid,
    isFocused: isFocused,
    isChecked: isChecked,
    isActive: isActive,
    isHovered: isHovered,
    isIndeterminate: isIndeterminate,
    isDisabled: isDisabled,
    isReadOnly: isReadOnly,
    isRequired: isRequired
  };
  return {
    state: state,
    getRootProps: getRootProps,
    getCheckboxProps: getCheckboxProps,
    getIndicatorProps: getIndicatorProps,
    getInputProps: getInputProps,
    getLabelProps: getLabelProps,
    htmlProps: htmlProps
  };
}

function stopEvent(event) {
  event.preventDefault();
  event.stopPropagation();
} // src/use-initial-animation-state.tsx


var import_react2 = require("react");

function useInitialAnimationState(isChecked) {
  var _ref15 = (0, import_react2.useState)(isChecked),
      _ref16 = _slicedToArray(_ref15, 2),
      previousIsChecked = _ref16[0],
      setPreviousIsChecked = _ref16[1];

  var _ref17 = (0, import_react2.useState)(false),
      _ref18 = _slicedToArray(_ref17, 2),
      shouldAnimate = _ref18[0],
      setShouldAnimate = _ref18[1];

  if (isChecked !== previousIsChecked) {
    setShouldAnimate(true);
    setPreviousIsChecked(isChecked);
  }

  return shouldAnimate;
} // src/checkbox.tsx


var import_jsx_runtime2 = require("react/jsx-runtime");

var controlStyles = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  verticalAlign: "top",
  userSelect: "none",
  flexShrink: 0
};
var rootStyles = {
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  verticalAlign: "top",
  position: "relative"
};
var checkAnim = (0, import_system2.keyframes)({
  from: {
    opacity: 0,
    strokeDashoffset: 16,
    transform: "scale(0.95)"
  },
  to: {
    opacity: 1,
    strokeDashoffset: 0,
    transform: "scale(1)"
  }
});
var indeterminateOpacityAnim = (0, import_system2.keyframes)({
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
});
var indeterminateScaleAnim = (0, import_system2.keyframes)({
  from: {
    transform: "scaleX(0.65)"
  },
  to: {
    transform: "scaleX(1)"
  }
});

var _Checkbox = (0, import_system2.forwardRef)(function Checkbox2(props, ref) {
  var group = useCheckboxGroupContext();

  var mergedProps = _objectSpread(_objectSpread({}, group), props);

  var styles = (0, import_system2.useMultiStyleConfig)("Checkbox", mergedProps);
  var ownProps = (0, import_system2.omitThemingProps)(props);

  var _ownProps$spacing = ownProps.spacing,
      spacing = _ownProps$spacing === void 0 ? "0.5rem" : _ownProps$spacing,
      className = ownProps.className,
      children = ownProps.children,
      iconColor = ownProps.iconColor,
      iconSize = ownProps.iconSize,
      _ownProps$icon = ownProps.icon,
      icon = _ownProps$icon === void 0 ? /* @__PURE__ */(0, import_jsx_runtime2.jsx)(_CheckboxIcon, {}) : _ownProps$icon,
      isCheckedProp = ownProps.isChecked,
      _ownProps$isDisabled = ownProps.isDisabled,
      isDisabled = _ownProps$isDisabled === void 0 ? group == null ? void 0 : group.isDisabled : _ownProps$isDisabled,
      onChangeProp = ownProps.onChange,
      inputProps = ownProps.inputProps,
      rest = _objectWithoutProperties(ownProps, _excluded3);

  var isChecked = isCheckedProp;

  if ((group == null ? void 0 : group.value) && ownProps.value) {
    isChecked = group.value.includes(ownProps.value);
  }

  var onChange = onChangeProp;

  if ((group == null ? void 0 : group.onChange) && ownProps.value) {
    onChange = (0, import_shared_utils2.callAll)(group.onChange, onChangeProp);
  }

  var _useCheckbox2 = _useCheckbox(_objectSpread(_objectSpread({}, rest), {}, {
    isDisabled: isDisabled,
    isChecked: isChecked,
    onChange: onChange
  })),
      state = _useCheckbox2.state,
      getInputProps = _useCheckbox2.getInputProps,
      getCheckboxProps = _useCheckbox2.getCheckboxProps,
      getLabelProps = _useCheckbox2.getLabelProps,
      getRootProps = _useCheckbox2.getRootProps;

  var shouldAnimate = useInitialAnimationState(state.isChecked);
  var iconStyles = (0, import_react3.useMemo)(function () {
    return _objectSpread({
      animation: !shouldAnimate ? void 0 : state.isIndeterminate ? "".concat(indeterminateOpacityAnim, " 20ms linear, ").concat(indeterminateScaleAnim, " 200ms linear") : "".concat(checkAnim, " 200ms linear"),
      fontSize: iconSize,
      color: iconColor
    }, styles.icon);
  }, [iconColor, iconSize, shouldAnimate, state.isIndeterminate, styles.icon]);
  var clonedIcon = (0, import_react3.cloneElement)(icon, {
    __css: iconStyles,
    isIndeterminate: state.isIndeterminate,
    isChecked: state.isChecked
  });
  return /* @__PURE__ */(0, import_jsx_runtime2.jsxs)(import_system2.chakra.label, _objectSpread(_objectSpread({
    __css: _objectSpread(_objectSpread({}, rootStyles), styles.container),
    className: (0, import_shared_utils2.cx)("chakra-checkbox", className)
  }, getRootProps()), {}, {
    children: [/* @__PURE__ */(0, import_jsx_runtime2.jsx)("input", _objectSpread({
      className: "chakra-checkbox__input"
    }, getInputProps(inputProps, ref))), /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_system2.chakra.span, _objectSpread(_objectSpread({
      __css: _objectSpread(_objectSpread({}, controlStyles), styles.control),
      className: "chakra-checkbox__control"
    }, getCheckboxProps()), {}, {
      children: clonedIcon
    })), children && /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_system2.chakra.span, _objectSpread(_objectSpread({
      className: "chakra-checkbox__label"
    }, getLabelProps()), {}, {
      __css: _objectSpread({
        marginStart: spacing
      }, styles.label),
      children: children
    }))]
  }));
});

_Checkbox.displayName = "Checkbox"; // src/checkbox-group.tsx

var import_react5 = require("react"); // src/use-checkbox-group.ts


var import_react_use_callback_ref2 = require("@chakra-ui/react-use-callback-ref");

var import_react_use_controllable_state = require("@chakra-ui/react-use-controllable-state");

var import_shared_utils3 = require("@chakra-ui/shared-utils");

var import_react4 = require("react");

function isInputEvent(value) {
  return value && (0, import_shared_utils3.isObject)(value) && (0, import_shared_utils3.isObject)(value.target);
}

function _useCheckboxGroup() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultValue = props.defaultValue,
      valueProp = props.value,
      onChange = props.onChange,
      isDisabled = props.isDisabled,
      isNative = props.isNative;
  var onChangeProp = (0, import_react_use_callback_ref2.useCallbackRef)(onChange);

  var _ref19 = (0, import_react_use_controllable_state.useControllableState)({
    value: valueProp,
    defaultValue: defaultValue || [],
    onChange: onChangeProp
  }),
      _ref20 = _slicedToArray(_ref19, 2),
      value = _ref20[0],
      setValue = _ref20[1];

  var handleChange = (0, import_react4.useCallback)(function (eventOrValue) {
    if (!value) return;
    var isChecked = isInputEvent(eventOrValue) ? eventOrValue.target.checked : !value.includes(eventOrValue);
    var selectedValue = isInputEvent(eventOrValue) ? eventOrValue.target.value : eventOrValue;
    var nextValue = isChecked ? [].concat(_toConsumableArray(value), [selectedValue]) : value.filter(function (v) {
      return String(v) !== String(selectedValue);
    });
    setValue(nextValue);
  }, [setValue, value]);
  var getCheckboxProps = (0, import_react4.useCallback)(function () {
    var _objectSpread2;

    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var checkedKey = isNative ? "checked" : "isChecked";
    return _objectSpread(_objectSpread({}, props2), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, checkedKey, value.some(function (val) {
      return String(props2.value) === String(val);
    })), _defineProperty(_objectSpread2, "onChange", handleChange), _objectSpread2));
  }, [handleChange, isNative, value]);
  return {
    value: value,
    isDisabled: isDisabled,
    onChange: handleChange,
    setValue: setValue,
    getCheckboxProps: getCheckboxProps
  };
} // src/checkbox-group.tsx


var import_jsx_runtime3 = require("react/jsx-runtime");

function _CheckboxGroup(props) {
  var colorScheme = props.colorScheme,
      size = props.size,
      variant = props.variant,
      children = props.children,
      isDisabled = props.isDisabled;

  var _useCheckboxGroup2 = _useCheckboxGroup(props),
      value = _useCheckboxGroup2.value,
      onChange = _useCheckboxGroup2.onChange;

  var group = (0, import_react5.useMemo)(function () {
    return {
      size: size,
      onChange: onChange,
      colorScheme: colorScheme,
      value: value,
      variant: variant,
      isDisabled: isDisabled
    };
  }, [size, onChange, colorScheme, value, variant, isDisabled]);
  return /* @__PURE__ */(0, import_jsx_runtime3.jsx)(CheckboxGroupProvider, {
    value: group,
    children: children
  });
}

_CheckboxGroup.displayName = "CheckboxGroup"; // Annotate the CommonJS export names for ESM import in node:

0 && (module.exports = {
  Checkbox: _Checkbox,
  CheckboxGroup: _CheckboxGroup,
  CheckboxIcon: _CheckboxIcon,
  useCheckbox: _useCheckbox,
  useCheckboxGroup: _useCheckboxGroup
});